module.exports = __webpack_public_path__ + "static/media/ilo_contact_1.84f6820c.png";